import React from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
const Container = (props) => {
    return (React.createElement(ContainerStyled, { style: props.style, className: `container ${props.className}` }, props.children));
};
export default Container;
const ContainerStyled = styled.div `
  &.container {
    margin-right: auto;
    margin-left: auto;
    padding-left: ${THEME.GRID_SPACING / 2}px;
    padding-right: ${THEME.GRID_SPACING / 2}px;
  }
  @media (min-width: 768px) {
    &.container {
      width: 750px;
    }
  }
  @media (min-width: 992px) {
    &.container {
      width: 970px;
    }
  }
  @media (min-width: 1200px) {
    &.container {
      width: 1170px;
    }
  }
  &.container:before,
  &.container:after {
    content: ' ';
    display: table;
  }
  &.container:after {
    clear: both;
  }
`;
//# sourceMappingURL=Container.js.map